import React, { useContext } from 'react';
import Grid from '@material-ui/core/Grid';

import EmailBody from '../engine/TextEditorEngine';
import { EmailBodyWrapper, SubjectInput } from './ComposeEmailView';
import { Context } from '../engine/EmailDialogEngine';

import styled from 'styled-components/macro';

const AdditionalSettingWrapper = styled.div`
  margin-top: 0.6em;
`;

const EditEmailTemplateView = props => {
  const {
    initLoader,
    dispatch,
    placeHolders,
    additionalPlaceHolders,
    additionalPlaceHoldersProps,
    noSubject,
    topEndPoint
  } = useContext(Context);

  return (
    <>
      {topEndPoint}
      {/* Subject input */}
      {noSubject ? null : (
        <>
          <Grid
            container
            spacing={2}
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item sm={1}>
              Subject
            </Grid>
            <Grid item sm>
              <SubjectInput
                data-testid="subject-input"
                value={props.subject}
                onChange={e => {
                  dispatch({
                    type: 'update',
                    payload: { subjectInEdit: e.target.value }
                  });
                  props.setIsDirty(true);
                }}
                fullWidth
                size="small"
              />
            </Grid>
          </Grid>
        </>
      )}
      {props.additionalSettings && (
        <AdditionalSettingWrapper>
          {props.additionalSettings}
        </AdditionalSettingWrapper>
      )}

      {/* Body input */}
      <EmailBodyWrapper>
        {!initLoader && (
          <EmailBody
            onChange={value => {
              dispatch({ type: 'update', payload: { bodyInEdit: value } });
              props.setIsDirty(true);
            }}
            fieldsPlaceholders={placeHolders}
            additionalPlaceHolders={additionalPlaceHolders}
            additionalPlaceHoldersProps={additionalPlaceHoldersProps}
            editorHeight={405}
            editorText={props.body}
          />
        )}
      </EmailBodyWrapper>
    </>
  );
};

export default EditEmailTemplateView;
